import { render, staticRenderFns } from "./tableProductsForApproval.vue?vue&type=template&id=5e7bc1ad&scoped=true"
import script from "./tableProductsForApproval.vue?vue&type=script&lang=js"
export * from "./tableProductsForApproval.vue?vue&type=script&lang=js"
import style0 from "./tableProductsForApproval.vue?vue&type=style&index=0&id=5e7bc1ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7bc1ad",
  null
  
)

export default component.exports